import React from 'react'
import Helmet from 'react-helmet'
import Header from './Header'
import Footer from './Footer'
import PropTypes from 'prop-types'

export default function Page({
  children,
  title,
  description,
  image,
  className = '',
}) {
  return (
    <div>
      <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        {image && <meta name="og:image" content={image} />}
      </Helmet>
      <Header />
      <main className={className}>{children}</main>
      <Footer />
    </div>
  )
}

Page.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Page.js